/**
 * The soft-tint status pill every list screen uses.
 *
 * Shared rather than styled per screen because Phase 2 brings nine more lists, and a status that is
 * green on one screen and grey on the next is how an operator learns to stop trusting the colour.
 * The tone names what the row *is*, not what colour to draw — a screen never picks a hex, and now
 * never picks a class either: these are the template's own `*-transparent` pairs, so a palette
 * change in `style.css` reaches the badges without anyone remembering this file.
 */
export type { StatusTone } from '@core/vocabulary';
import type { StatusTone } from '@core/vocabulary';

const tones: Record<StatusTone, string> = {
  positive: 'bg-success-transparent text-success',
  brand: 'bg-primary-transparent text-primary',
  warning: 'bg-warning-transparent text-warning',
  negative: 'bg-danger-transparent text-danger',
  neutral: 'bg-light text-default',
};

export function StatusBadge({ tone, children }: { tone: StatusTone; children: React.ReactNode }) {
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-[length:var(--scale-badge)] font-medium whitespace-nowrap ${tones[tone]}`}
    >
      {children}
    </span>
  );
}
